import * as React from "react";
import { MobXProviderContext, observer } from "mobx-react";
import { Box, Collapse, Grid, Typography } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import { useTheme } from "@material-ui/core/styles";
import cx from "classnames";
import * as styles from "./styles.scss";

import { SvgIcon } from "../../../../../../components";

import { FilesList } from "../../Fileslist/index";
import { themeVariables } from "../../../../MUI";

interface IProps {
  group: any;
  APIUrl: string;
  isLast?: boolean;
}

export const FileslistsGroup = observer((props: IProps) => {
  const { fsCourseStore } = React.useContext(MobXProviderContext);
  const theme = useTheme();
  const [expanded, setExpanded] = React.useState(true);

  const getGroupId = () => {
    return fsCourseStore.filesSection === "lessons"
      ? { lesson_id: props.group.id }
      : fsCourseStore.filesSection === "homeworks"
      ? { person_id: props.group.id }
      : fsCourseStore.filesSection === "chats"
      ? { chat_id: props.group.id }
      : undefined;
  };

  return (
    <>
      <Box
        flex={1}
        px={2}
        py={1}
        bgcolor={theme.palette.grey.A100}
        onClick={() => setExpanded(!expanded)}
        borderRadius={
          themeVariables.blockRadius
            ? `${themeVariables.blockRadius}px ${themeVariables.blockRadius}px 0 0`
            : undefined
        }
        className={cx("react-hideBgOnHover", {
          [styles.groupHead]: true,
          [styles.groupHeadCarded]: fsCourseStore.isFileslistCarded,
          [styles.groupHeadCardedShrinked]:
            fsCourseStore.isFileslistCarded && !expanded,
        })}
      >
        <Grid container spacing={1} alignItems="center" wrap="nowrap">
          <Box clone alignSelf="flex-start">
            <Grid item>
              {props.group.icon ? (
                <img
                  src={`/media/192/${window.btoa(props.group.icon)}`}
                  alt=""
                  className={cx({
                    [styles.groupIcon]: true,
                    "filestorage-user":
                      fsCourseStore.filesSection === "homeworks" ||
                      fsCourseStore.filesSection === "chats",
                  })}
                />
              ) : fsCourseStore.filesSection === "homeworks" ||
                (fsCourseStore.filesSection === "chats" &&
                  fsCourseStore.filesSectionTab === "private") ? (
                <Box
                  className={`${styles.groupIconType} ${styles.groupIconTypeUser}`}
                />
              ) : fsCourseStore.filesSection === "chats" ? (
                <Box
                  className={`${styles.groupIconType} ${styles.groupIconTypeChat}`}
                />
              ) : (
                <Box className={`${styles.groupIconType} ${props.group.type}`}>
                  <SvgIcon
                    type={`lessontype_${props.group.type}`}
                    modifier="small"
                  />
                </Box>
              )}
            </Grid>
          </Box>
          <Grid item xs zeroMinWidth className={styles.groupName}>
            <Box fontWeight={600}>{props.group.groupName}</Box>
            <Box mt="1px" clone>
              <Typography variant="body2" color="textSecondary">
                {props.group.groupCategory}
              </Typography>
            </Box>
          </Grid>
          <Grid item>
            <Box display="flex" alignItems="center" clone>
              <Typography variant="subtitle2">
                {expanded ? (
                  <ArrowDropUpIcon
                    style={{ color: theme.palette.primary.light }}
                  />
                ) : (
                  <ArrowDropDownIcon
                    style={{ color: theme.palette.primary.light }}
                  />
                )}
                {props.group.filesCount}
                <Box component="span" ml={0.5}>
                  <SvgIcon type="fs-list-filesgroup" />
                </Box>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Collapse in={expanded}>
        <Box
          flex="1"
          className={cx({
            [styles.groupItems]: true,
            [styles.groupItemsCarded]: fsCourseStore.isFileslistCarded,
          })}
        >
          <FilesList
            {...getGroupId()}
            groupedFiles={props.group.files}
            APIUrl={props.APIUrl}
          />
        </Box>
      </Collapse>
    </>
  );
});
